import toFrenchFloat from './to-french-float'
import toThousand from './to-thousand'
import toFixed from './to-fixed'

export default function displayAmount (value, decimals = 2) {
  return toFrenchFloat(toThousand(toFixed(value, decimals)))
}